import React, { useState } from 'react';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, Typography, Box } from '@mui/material';

const AddProvider = ({ setMessage }) => {
  const [displayName, setDisplayName] = useState('');
  const [providerType, setProviderType] = useState('ALS');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!displayName.trim()) {
      setMessage('Please enter a display name.');
      return;
    }

    try {
      const docRef = doc(db, 'hvac', 'GenericData', 'Providers', 'ProvidersList');
      await updateDoc(docRef, {
        [providerType]: arrayUnion(displayName)
      });
      setMessage(`Successfully added ${displayName} to ${providerType} providers.`);
      setDisplayName('');
    } catch (error) {
      console.error('Error adding provider:', error);
      setMessage('Error adding provider. Please try again.');
    }
  };

  return (
    <Box className="form-container" sx={{ padding: 2, borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h5" gutterBottom>Add Provider</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Display Name"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          required
          margin="normal"
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Provider Type</InputLabel>
          <Select
            value={providerType}
            onChange={(e) => setProviderType(e.target.value)}
          >
            <MenuItem value="ALS">ALS</MenuItem>
            <MenuItem value="BLS">BLS</MenuItem>
          </Select>
        </FormControl>
        <Button type="submit" variant="contained" color="primary">Add Provider</Button>
      </form>
    </Box>
  );
};

export default AddProvider;
